var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2Circle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38.311,
    viewBox: "0 0 38 38.311",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_write",
    transform: "translate(0 0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24384",
    "data-name": "Group 24384",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2046",
    "data-name": "Ellipse 2046",
    transform: "translate(0 -0.16)",
    fill: "#fff",
    stroke: "#44454a",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 19,
    cy: 19.156,
    rx: 19,
    ry: 19.156,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 19,
    cy: 19.156,
    rx: 18.5,
    ry: 18.656,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": 2,
    transform: "translate(14 25.841)",
    fontSize: 18,
    fontFamily: "HelveticaNeue-Medium, Helvetica Neue",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Circle);
export default __webpack_public_path__ + "static/media/2-circle.fcd70466e749c62cbd6585162de388be.svg";
export { ForwardRef as ReactComponent };